// NL werkdag/feestdag helpers — frontend twin van backend
const NL_FEESTDAGEN_VARIABEL = {
  2025: { '04-18': 'Goede Vrijdag', '04-21': '2e Paasdag', '05-29': 'Hemelvaart', '06-09': '2e Pinksterdag' },
  2026: { '04-03': 'Goede Vrijdag', '04-06': '2e Paasdag', '05-14': 'Hemelvaart', '05-25': '2e Pinksterdag' },
  2027: { '03-26': 'Goede Vrijdag', '03-29': '2e Paasdag', '05-06': 'Hemelvaart', '05-17': '2e Pinksterdag' },
  2028: { '04-14': 'Goede Vrijdag', '04-17': '2e Paasdag', '05-25': 'Hemelvaart', '06-05': '2e Pinksterdag' },
  2029: { '03-30': 'Goede Vrijdag', '04-02': '2e Paasdag', '05-10': 'Hemelvaart', '05-21': '2e Pinksterdag' },
  2030: { '04-19': 'Goede Vrijdag', '04-22': '2e Paasdag', '05-30': 'Hemelvaart', '06-10': '2e Pinksterdag' },
};

export function feestdagNaam(date) {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = d.getMonth() + 1;
  const day = d.getDate();
  if (m === 1 && day === 1) return 'Nieuwjaarsdag';
  if (m === 4 && day === 27) return 'Koningsdag';
  if (m === 12 && day === 25) return '1e Kerstdag';
  if (m === 12 && day === 26) return '2e Kerstdag';
  const mmdd = String(m).padStart(2,'0') + '-' + String(day).padStart(2,'0');
  return (NL_FEESTDAGEN_VARIABEL[y] || {})[mmdd] || null;
}

export function isFeestdag(date) {
  return feestdagNaam(date) !== null;
}
